import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import { CircularProgress } from '@mui/material'
import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getClientId } from 'src/utils/commonMethods'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { TOP_CLAIMS_DATA } from 'src/services/individualService'

const TopClaims = () => {
  const classes = useStyles()
  const params = useParams()
  const userInfo = useSelector((state) => state?.userInfo)
  const [topClaims, setTopClaims] = useState([])
  const {
    loading: topClaimsLoading,
    error: topClaimsError,
    data: topClaimsData,
  } = useQuery(TOP_CLAIMS_DATA(getClientId(params?.id, userInfo)), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    if (topClaimsData) {
      if (topClaimsData?.getTopClaims?.employeeBenefits?.length !== 0) {
        setTopClaims(
          topClaimsData?.getTopClaims?.employeeBenefits
            ?.slice()
            ?.sort((a, b) => b?.claimAmount - a?.claimAmount) ?? []
        )
      }
    }
  }, [topClaimsData])
  if (topClaimsLoading)
    return (
      <div className='loadingContainer'>
        <CircularProgress />
      </div>
    )
  if (topClaimsError) {
    return (
      <div>
        <GraphQlErrors error={topClaimsError} />
      </div>
    )
  }
  const getValue = (value) => {
    let val = Math.abs(value)
    if (!isNaN(val)) {
      if (val >= 10000000) {
        val = (val / 10000000)?.toFixed(1) + ' Cr'
      } else if (val >= 100000) {
        val = (val / 100000)?.toFixed(1) + ' L'
      } else if (val >= 1000) {
        val = Math.round(val / 1000) + ' K'
      }
      return val
    }
    return '---'
  }
  return (
    <div className={classes.root}>
      <h2 className={classes.title}> Top Claims</h2>
      <div className={classes.listWrapper}>
        {topClaims?.length !== 0 ? (
          topClaims?.map((item) => {
            return (
              <div
                className={classes.listItem}
                key={`topClaim_${item?.employeeName}`}
                id='topClaimListItem'
              >
                <div className={classes.label}>
                  <div> {item?.employeeName}</div>
                  <div className={classes.claimPolicyName}>
                    {item?.policyName}
                  </div>
                </div>
                <div className={classes.value}>
                  {getValue(item?.amountClaimed ?? item?.claimAmount)}
                </div>
              </div>
            )
          })
        ) : (
          <div id='noDataText' className={classes.nodata}>
            No Claims
          </div>
        )}
      </div>
    </div>
  )
}

export default TopClaims
const useStyles = makeStyles({
  root: {
    backgroundColor: COLORS.WHITE,
    width: '25vw',
    height: '281px',
    overflowX: 'hidden',
    position: 'relative',
    borderRadius: '10px',
    border: '1px solid rgba(0,0,0,.125)',
    boxShadow: '4px 7px 15px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '20px',
    // padding: "0px 24px",
    textAlign: 'center',
    color: '#333333',
    fontWeight: '600',
  },
  listWrapper: { padding: '0px 45px' },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    padding: '12px 0px 5px 0px',
    textAlign: 'left',
  },
  label: {
    fontSize: '13px',
    color: '#333333',
    marginBottom: '10px',
    lineHeight: '16px',
    padding: '0px',
    flexGrow: 1,
    fontWeight: '600',
    wordBreak: 'break-word',
  },
  value: {
    fontSize: '16px',
    color: '#B92250',
    fontWeight: 'bold',
    lineHeight: '20px',
    flexBasis: '50px',
    flexShrink: 0,
  },
  nodata: {
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#B92250',
  },
  claimPolicyName: {
    fontSize: '12px',
    color: '#B92250',
    fontWeight: 'bold',
  },
})
